module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-content-title"
  }, [_c('div', {
    staticClass: "form-content-title-block form-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-title-block"
  }, [(_vm.$store.state.user.attributes.permissions_keys.includes(15)) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'shipments-create'
      }
    }
  }, [_vm._v("Nuevo Embarque")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-content-title-block filter-container"
  }, [_c('div', {
    staticClass: "filter-block filter-block-various"
  }, [_c('label', [_vm._v("Buscar por")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterBy),
      expression: "tableData.filterBy"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-search"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "filterBy", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.cleanInput()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.filterColumns), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.name
      }
    }, [_vm._v(_vm._s(option.label))])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.filterValue),
      expression: "tableData.filterValue"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-bar",
      "type": "search",
      "placeholder": "Buscar..."
    },
    domProps: {
      "value": (_vm.tableData.filterValue)
    },
    on: {
      "keyup": function($event) {
        return _vm.getBoardings()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tableData, "filterValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-block filter-block-alone filter-block-ship"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('div', {
    staticClass: "filter-block-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableData.status),
      expression: "tableData.status"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tableData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getBoardings()
      }]
    }
  }, _vm._l((_vm.statusGroupArray), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(_vm.statusGroupArray[index]))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-ship"
  }, [(_vm.is_loading == false) ? _c('data-table', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [(_vm.boardings != null && _vm.boardings.length > 0) ? _c('tbody', _vm._l((_vm.boardings), function(boarding) {
    return _c('tr', {
      key: boarding.id,
      on: {
        "click": function($event) {
          return _vm.toEditShipmentView(boarding.id, boarding.attributes.status)
        }
      }
    }, [_c('td', [_c('span', [_vm._v(_vm._s(boarding.id))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ruta-order-container"
    }, [_c('div', {
      staticClass: "ruta-order-block ruta-order-image"
    }, [_c('img', {
      attrs: {
        "src": "/static/img/ruta.svg",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-block"
    }, [_c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(boarding.attributes.origin.attributes.name))])]), _vm._v(" "), _c('div', {
      staticClass: "ruta-order-content"
    }, [_c('span', [_vm._v(_vm._s(boarding.attributes.destination.attributes.name))])])])])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDateTime")(boarding.attributes.departure_date)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDateTime")(boarding.attributes.arrival_date)))])]), _vm._v(" "), _c('td', [_c('span', [_c('div', {
      staticClass: "order-tag-container"
    }, [(boarding.attributes.status >= 1 && boarding.attributes.status <= 3) ? _c('span', {
      staticClass: "order-tag order-init"
    }, [_vm._v(_vm._s(_vm.statusGroupArray[10]))]) : (boarding.attributes.status >= 5 && boarding.attributes.status <= 7) ? _c('span', {
      staticClass: "order-tag order-process"
    }, [_vm._v(_vm._s(_vm.statusGroupArray[20]))]) : (boarding.attributes.status == 4) ? _c('span', {
      staticClass: "order-tag order-cancel"
    }, [_vm._v(_vm._s(_vm.statusGroupArray[30]))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "order-tag order-message"
    }, [_vm._v(_vm._s(_vm.boardingStatusArray[boarding.attributes.status]))])])])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("spanishDateTime")(boarding.attributes.updated_at.date)))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "bpadding": "0"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "150px"
      }
    }, [_c('span', [_vm._v("Paquetes : " + _vm._s(boarding.attributes.packages_total) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Ordenes : " + _vm._s(boarding.attributes.purchaseorder_total) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Peso : " + _vm._s(boarding.attributes.boarding_weight) + " Kg")]), _c('br')])])])
  }), 0) : _c('tbody', [_c('div', {
    staticClass: "no-results"
  }, [_c('h1', [_vm._v("No se encontraron resultados")])])])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.is_loading == false) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination
    },
    on: {
      "changePagination": _vm.getBoardings
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-title-block form-title-principal"
  }, [_c('span', [_vm._v("Embarques")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f36163e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shipment-list-view.vue
// module id = 1902
// module chunks = 1